import { environment } from '../environments/environment';
const VARS = { API_BASE_URL: environment.apiUrl };
export { VARS }

